import { render } from "./AlertReport.vue?vue&type=template&id=93d7791a&scoped=true"
import script from "./AlertReport.vue?vue&type=script&lang=js"
export * from "./AlertReport.vue?vue&type=script&lang=js"

import "./AlertReport.vue?vue&type=style&index=0&id=93d7791a&scoped=true&lang=css"

import exportComponent from "/home/azael/Documents/GitHub/tempo-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93d7791a"]])

export default __exports__